import { render, staticRenderFns } from "./M2hProfile.vue?vue&type=template&id=147966e2&scoped=true&"
import script from "./M2hProfile.vue?vue&type=script&lang=js&"
export * from "./M2hProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147966e2",
  null
  
)

export default component.exports